export const getApiBaseUrl = (): string => {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_API_URL ?? '';
  }

  return globalThis.window.location.origin;
};
